module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-433.02283f8.woff2";